import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ChevronRight, ArrowLeft, Users } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function Reportes() {
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [loadingCourses, setLoadingCourses] = useState(true);
    const [courseQuery, setCourseQuery] = useState("");
    const [selectedCourse, setSelectedCourse] = useState(null);

    const [students, setStudents] = useState([]);
    const [loadingStudents, setLoadingStudents] = useState(false);
    const [studentQuery, setStudentQuery] = useState("");

    useEffect(() => {
        api.get("/courses")
            .then((r) => setCourses(r.data || []))
            .catch(() => toast.error("Error cargando cursos"))
            .finally(() => setLoadingCourses(false));
    }, []);

    function selectCourse(course) {
        setSelectedCourse(course);
        setStudentQuery("");
        setLoadingStudents(true);
        api.get(`/courses/${course.id}/students`)
            .then((r) => setStudents(r.data || []))
            .catch(() => toast.error("Error cargando alumnos del curso"))
            .finally(() => setLoadingStudents(false));
    }

    const filteredCourses = courses.filter((c) =>
        `${c.name} ${(c.sections || []).join(" ")}`.toLowerCase().includes(courseQuery.toLowerCase())
    );
    const filteredStudents = students.filter((s) =>
        (s.name || "").toLowerCase().includes(studentQuery.toLowerCase())
    );

    if (!selectedCourse) {
        return (
            <div className="p-6 md:p-10 fade-in min-h-screen max-w-2xl mx-auto">
                <h1 className="text-2xl font-semibold mb-1">Reportes</h1>
                <p className="text-edu-muted mb-6">Elige un curso para ver el reporte semanal de un alumno.</p>

                <div className="relative mb-4">
                    <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-edu-muted" />
                    <input
                        value={courseQuery}
                        onChange={(e) => setCourseQuery(e.target.value)}
                        placeholder="Buscar curso…"
                        className="edu-input w-full pl-9"
                    />
                </div>

                {loadingCourses ? (
                    <p className="text-sm text-edu-muted">Cargando…</p>
                ) : filteredCourses.length === 0 ? (
                    <div className="edu-card p-8 text-center text-edu-muted">No se encontraron cursos.</div>
                ) : (
                    <div className="space-y-2">
                        {filteredCourses.map((c) => (
                            <button
                                key={c.id}
                                onClick={() => selectCourse(c)}
                                className="edu-card w-full text-left p-4 hover:bg-edu-soft transition-colors flex items-center justify-between gap-3"
                            >
                                <div className="flex items-center gap-3">
                                    <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ background: c.color }} />
                                    <div>
                                        <p className="font-medium text-sm">{c.name}</p>
                                        <p className="text-xs text-edu-muted">{(c.sections || []).join(", ")}</p>
                                    </div>
                                </div>
                                <ChevronRight size={16} className="text-edu-muted" />
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="p-6 md:p-10 fade-in min-h-screen max-w-2xl mx-auto">
            <button onClick={() => setSelectedCourse(null)} className="inline-flex items-center gap-2 text-sm text-edu-body hover:text-edu-navy mb-6">
                <ArrowLeft size={16} /> Cambiar curso
            </button>

            <h1 className="text-2xl font-semibold mb-1">{selectedCourse.name}</h1>
            <p className="text-edu-muted mb-6">{(selectedCourse.sections || []).join(", ")} — busca al alumno para ver su reporte.</p>

            <div className="relative mb-4">
                <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-edu-muted" />
                <input
                    value={studentQuery}
                    onChange={(e) => setStudentQuery(e.target.value)}
                    placeholder="Buscar alumno por nombre…"
                    className="edu-input w-full pl-9"
                    autoFocus
                />
            </div>

            {loadingStudents ? (
                <p className="text-sm text-edu-muted">Cargando…</p>
            ) : filteredStudents.length === 0 ? (
                <div className="edu-card p-8 text-center text-edu-muted inline-flex flex-col items-center gap-2 w-full">
                    <Users size={20} />
                    {students.length === 0 ? "No hay alumnos matriculados en las secciones de este curso." : "Ningún alumno coincide con la búsqueda."}
                </div>
            ) : (
                <div className="space-y-2">
                    {filteredStudents.map((s) => (
                        <button
                            key={s.id}
                            onClick={() => navigate(`/profesor/reportes/${selectedCourse.id}/${s.id}`)}
                            className="edu-card w-full text-left p-4 hover:bg-edu-soft transition-colors flex items-center justify-between gap-3"
                        >
                            <div>
                                <p className="font-medium text-sm">{s.name}</p>
                                <p className="text-xs text-edu-muted">{s.grade}</p>
                            </div>
                            <ChevronRight size={16} className="text-edu-muted" />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
